import React from 'react';
import Matematicaimg from '../imgs/matematica.png';
import { Link } from 'react-router-dom';

const Matematica = () => {
    return (
        <div>
            <img className="full-width-img" src={Matematicaimg}></img>
            <div className="fundo">
                <h1 className="fontezaocor">INTRODUÇÃO</h1>
                <br/>
                <div className="text-container">
                    <h4 className="fontezao2cor">Por que π está em todos os lugares? O que é o infinito?</h4>
                </div>
                <div className="text-container">
                    <h4 className="cor">
                    A matemática não é apenas uma linguagem "chata" — ela é essencial para <span className="destaque2">simbolizar</span> todas as <span className="destaque2">dúvidas</span> da humanidade que surgem nas demais ciências exatas. É por meio da matemática que conseguimos descrever quantitativamente tudo o que acontece no universo. E não, <span className="destaque2">isso não tem nada a ver com decorar tabuadas ou produtos notáveis,</span> mas sim com compreender um sistema incrível capaz de capturar a beleza e a lógica da <span className="destaque2">natureza</span>.
                    </h4>
                </div>
                <h1 className="fontezaocor">OLÍMPIADAS</h1>
                <br/>
                <div className="text-container">
                    <h4 className="cor">
                    No Brasil, existem diversas olimpíadas de matemática para quem deseja explorar o fascinante mundo dos números e padrões. Em nível nacional, destacam-se a <span className="destaque2">OBM</span> (Olimpíada Brasileira de Matemática) e a <span className="destaque2">OBMEP</span> (Olimpíada Brasileira de Matemática das Escolas Públicas). Já em nível internacional, os brasileiros podem participar de desafios como a <span className="destaque2">IMO</span> (Olimpíada Internacional de Matemática), a <span className="destaque2">APMO</span> (Asian Pacific Mathematics Olympiad), a <span className="destaque2">EGMO</span> (European Girls’ Mathematical Olympiad) e muitas outras competições.
                    </h4>
                </div>
                <br/>
                <div className="button-container">
                    <Link className="last" to="/matemática-materiais">
                        <button className="botao-transparente2">MATERIAIS</button>
                    </Link>
                    <Link className="last" to="/matemática-problemas">
                        <button className="botao-transparente2">PROBLEMAS MENSAIS</button>
                    </Link>
                    <Link className="last" to="/matemática-gabaritos">
                        <button className="botao-transparente2">GABARITOS COMENTADOS</button>
                    </Link>
                </div>
                <br/>
            </div>
        </div>
    );
};

export default Matematica;